import React from "react"
import IntroSection from "../components/IntroSection";
import NearSolutions from "../components/NearSolutions";
import BlueSectionDivider from "../components/BlueSectionDivider";
import NearProcess from "../components/NearProcess";
import CustomerTestimonials from "../components/CustomerTestimonials";
import NearBenefits from "../components/NearBenefits";
import SoftwareAwards from "../components/SoftwareAwards";
import CountriesSection from "../components/CountriesSection";
import NearProjects from "../components/NearProjects";
import TeamSection from "../components/TeamSection";
import WhyUsSection from "../components/WhyUsSection";
import TechStackSection from "../components/TechStackSection";
import NearFaq from "../components/NearFaq";
import NearResources from "../components/NearResources";
import ContactSection from "../components/ContactSection";
import Footer from "../components/Footer";

const NearshoreTeams = () => {
    return (
        <div>
            <IntroSection title = "NEARSHORE TEAMS" paragraph="Build faster, better, and bigger software. World-class nearshore teams for enterprises and scale-ups." backgroundImage="/images/sd-bg.webp"/>
            <NearSolutions/>
            <BlueSectionDivider/>
            <NearProcess/>
            
            <NearBenefits/>
           
            <CountriesSection/>
            <BlueSectionDivider/>
            <NearProjects/>
            <BlueSectionDivider/>
            <TeamSection/>
            <WhyUsSection/>
            <TechStackSection/>
            <BlueSectionDivider/>
            <NearFaq/>
            <BlueSectionDivider/>
         
            <ContactSection backgroundColor="#057af0ff"/>
            <Footer/>

        </div>
    )
}
export default NearshoreTeams;